import {
  Avatar,
  Box,
  Divider,
  Paper,
  Stack,
  Typography,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material'
import {styled} from '@mui/material/styles'
import CircleIcon from '@mui/icons-material/Circle'

export const StyledOutreachTooltipHeader = styled(Typography)(({theme}) => ({
  textAlign: 'left',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledPersonaTooltipHeader = styled(Typography)(({theme}) => ({
  textAlign: 'left',
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.personaTooltipHeader,
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledOutreachTooltipTitle = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.info.main
}))

export const StyledOutreachTooltipStatValue = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.hpAccentBlack,
  marginLeft: theme.spacing(1)
}))

export const StyledTooltipRow = styled(Box)(({theme}) => ({
  textAlign: 'left',
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.subtitle1.fontSize,
  display: 'flex',
  alignItems: 'center'
}))

const PREFIX = 'HouseholdTooltip'
export const classesHT = {
  paper: `${PREFIX}-paper`,
  customBox: `${PREFIX}-customBox`,
  typography: `${PREFIX}-typography`,
  typography2: `${PREFIX}-typography2`,
  typography3: `${PREFIX}-typography3`,
  typography4: `${PREFIX}-typography4`,
  typographyColor: `${PREFIX}-typographyColor`,
  divider: `${PREFIX}-divider`
}

export const StyledBox = styled(Box)(({theme}) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,

  [`& .${classesHT.paper}`]: {
    maxWidth: '450px',
    borderRadius: '8px'
  },
  [`& .${classesHT.customBox}`]: {
    padding: 20
  },
  [`& .${classesHT.typography}`]: {
    marginLeft: `${theme.spacing(1 / 2)}`,
    color: theme.palette.grey[600],
    fontWeight: theme.typography.fontWeightBold
  },
  [`& .${classesHT.typography2}`]: {
    color: theme.palette.hpAccentBlack,
    lineHeight: theme.typography.h5.lineHeight,
    fontWeight: theme.typography.fontWeightMedium
  },
  [`& .${classesHT.typography3}`]: {
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightSemibold
  },
  [`& .${classesHT.typography4}`]: {
    textTransform: 'uppercase',
    color: (theme) => theme.palette.hpAccentBlack,
    lineHeight: theme.typography.h5.lineHeight
  },
  [`& .${classesHT.typographyColor}`]: {
    color: theme.palette.hpAccentDarkerPink
  }
}))

export const StyledPaper = styled(Box)(() => ({
  borderRadius: '8px'
}))

export const StyledTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  lineHeight: theme.typography.h5.lineHeight,
  fontWeight: theme.typography.fontWeightMedium
}))

export const StyledDivider = styled(Divider)(() => ({
  width: '100%'
}))

export const StyledTileLayerDivider = styled(Divider)(() => ({
  width: 'calc(100% + 20px)',
  margin: '8px -10px'
}))

export const StyledPersonalInfo = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'column'
}))

export const StyledInfoBox = styled(Typography)(() => ({
  display: 'flex',
  flexFlow: 'column',
  textTransform: 'uppercase',
  alignItems: 'space-around'
}))

export const StyledInfo = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentDarkPink,
  lineHeight: theme.typography.h5.lineHeight
}))

export const StyledTitle = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentDarkPink
}))

export const StyledAddress = styled(Typography)(({theme}) => ({
  textTransform: 'uppercase',
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.palette.hpBaseDarkest,
  fontWeight: theme.typography.displayXlarge.fontWeight
}))

export const StyledPOITooltipContainer = styled(Paper)(({theme}) => ({
  maxWidth: '250px',
  borderRadius: '8px',
  fontFamily: theme.typography.fontFamily
}))

export const StyledTooltipSection = styled(Box)(({theme}) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`
}))

export const StyledAvatar = styled(Avatar)(() => ({
  width: '24px',
  height: '24px'
}))

export const StyledAddressTitle = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.hpAccentBlack,
  fontSize: theme.typography.subtitle1.fontSize
}))

export const StyledAddressContainer = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  letterSpacing: '0.2px',
  lineHeight: '24px'
}))

export const StyledPOITitle = styled(Typography)(({theme}) => ({
  margin: '4px 4px',
  display: 'inline',
  color: theme.palette.grey[600],
  fontWeight: 'bold'
}))

export const StyledPOI = styled(Typography)(() => ({
  wordBreak: 'break-word'
}))

export const classesT = {
  paper: `${PREFIX}-paper`,
  customBox: `${PREFIX}-customBox`,
  subtitle1: `${PREFIX}-subtitle1`,
  labelMedium: `${PREFIX}-labelMedium`,
  body1: `${PREFIX}-body1`,
  body2: `${PREFIX}-body2`,
  labelSmall: `${PREFIX}-labelSmall`,
  labelSmallPersona: `${PREFIX}-labelSmallPersona`,
  tooltipData: `${PREFIX}-tooltipData`,
  subtitle2: `${PREFIX}-subtitle2`,
  icon: `${PREFIX}-icon`,
  Circleicon: `${PREFIX}-Circleicon`,
  BenefitsEligibilityIcon: `${PREFIX}-BenefitsEligibilityIcon`,
  bracket: `${PREFIX}-bracket`,
  alignment: `${PREFIX}-alignment`,
  alignCenter: `${PREFIX}-alignCenter`,
  personaTooltip: `${PREFIX}-personaTooltip`,

  typography: `${PREFIX}-typography`,
  typography2: `${PREFIX}-typography2`,
  typography3: `${PREFIX}-typography3`,
  typography4: `${PREFIX}-typography4`,
  typographyColor: `${PREFIX}-typographyColor`,
  divider: `${PREFIX}-divider`
}

export const StyledBoxTooltip = styled(Box)(({theme, tooltipWidth}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: tooltipWidth,

  '& > :not(style)': {
    m: theme.spacing(1),
    p: theme.spacing(2),
    width: tooltipWidth || theme.spacing(52),
    maxHeight: '45vh',
    overflowY: 'auto'
  }
}))

export const StyledPaperTooltip = styled(Paper)(({theme}) => ({
  elevation: 1,
  padding: theme.spacing(1.25)
}))

export const StyledSpaceBox = styled(Box)(({size}) => ({
  height: `${size}px`
}))

export const StyledDividerTooltip = styled(Divider)(({theme}) => ({
  '&.MuiDivider-root': {
    borderColor: theme.palette.hpAccentTeal,
    background: theme.palette.hpAccentTeal,
    marginTop: theme.spacing(0.125)
  }
}))

export const PersonaBox = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.hpBaseLighter,
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5)
}))

// Styled Components
export const StyledSubtitle1 = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.hpBaseDarkest
}))

export const StyledLabelMedium = styled(Typography)(({theme}) => ({
  ...theme.typography.labelMedium,
  backgroundColor: theme.palette.info.light,
  color: theme.palette.hpAccentTeal,
  width: 'fit-content',
  padding: `0 ${theme.spacing(1.25)}`
}))

export const StyledBody1 = styled(Typography)(({theme}) => ({
  ...theme.typography.body1,
  color: theme.palette.hpBaseDarker
}))

export const StyledBody2 = styled(Typography)(({theme}) => ({
  ...theme.typography.body2,
  lineHeight: 1.8,
  color: theme.palette.hpBaseDarkest
}))

export const StyledLabelSmall = styled(Typography)(({theme}) => ({
  ...theme.typography.labelSmall,
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.hpBaseDarkest
}))

export const StyledTooltipData = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpBaseDarkest,
  fontWeight: theme.typography.displayXlarge.fontWeight
}))

export const StyledSubtitle2 = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.palette.hpBaseDarkest,
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(0.75)
}))

export const StyledLocationIcon = styled('div')(({theme}) => ({
  marginTop: theme.spacing(0.25),
  display: 'inline-flex',
  '& svg': {
    marginTop: theme.spacing(0.25)
  }
}))

export const StyledCircleIcon = styled(CircleIcon)(({theme}) => ({
  fontSize: theme.spacing(0.625),
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1)
}))

export const StyledBenefitsEligibilityIconContainer = styled('div')(({theme, colorIcon}) => ({
  width: theme.spacing(2.875),
  height: theme.spacing(2.875),
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: colorIcon ? `${colorIcon}1A` : theme.palette.success.light, // 1A = 10% opacity in hex
  color: colorIcon || theme.palette.success.main
}))

export const StyledBracketContainer = styled(Stack)(({theme}) => ({
  border: `1px solid ${theme.palette.grey[500]}`,
  padding: `0px ${theme.spacing(0.375)}`,
  borderTop: '1px solid transparent',
  borderImage: `linear-gradient(
    to right,
    ${theme.palette.grey[500]} 0 4%,
    transparent 4% 96%,
    ${theme.palette.grey[500]} 96% 100%
  ) 1`
}))

export const StyledAlignmentStack = styled(Stack)(() => ({
  justifyContent: 'space-between'
}))

export const StyledAlignCenterStack = styled(Stack)(() => ({
  alignItems: 'center'
}))

// Additional styled components for HouseholdTooltip
export const StyledLabelSmallPersona = styled(Typography)(({theme}) => ({
  ...theme.typography.labelSmall,
  fontWeight: theme.typography.fontWeightRegular,
  fontStyle: 'italic',
  color: theme.palette.hpOrangeDarker
}))

export const StyledDiseaseContainer = styled(Stack)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

export const StyledPersonaContainer = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}))

export const StyledPOIContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(0.5)
}))

export const StyledPOIHeaderStack = styled(Stack)(({theme}) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}))

export const StyledPersonaDescriptionText = styled(Typography)(({theme}) => ({
  marginBottom: theme.spacing(1)
}))

export const StyledPersonaAvatar = styled(Avatar)(() => ({
  width: 40,
  height: 40
}))

export const StyledPersonaHeaderStack = styled(Stack)(() => ({
  alignItems: 'start'
}))

export const StyledAccordion = styled(Accordion)(({theme}) => ({
  border: '1px solid #E0E0E0',
  borderRadius: theme.spacing(1 / 2),
  marginTop: theme.spacing(2),
  margin: 0,
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  boxShadow: 'none',
  '&:before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    margin: 0
  }
}))

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  padding: 0,
  margin: 0,
  minHeight: 'unset',
  '&.Mui-expanded': {
    minHeight: 'unset',
    margin: 0
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
    padding: 0,
    '&.Mui-expanded': {
      margin: 0
    }
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    margin: 0
  }
}))

export const StyledAccordionDetails = styled(AccordionDetails)(({theme}) => ({
  padding: 0,
  margin: 0,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}))

export const StyledPOIDetailsGrid = styled(Grid)(({theme}) => ({
  wordBreak: 'break-word',
  marginLeft: theme.spacing(1)
}))

export const StyledPOIDistanceGrid = styled(Grid)(({theme}) => ({
  textAlign: 'right',
  marginRight: theme.spacing(0.5)
}))

export const StyledPOIDistanceText = styled(Typography)(({theme}) => ({
  marginLeft: theme.spacing(2),
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpBaseDarkest,
  fontWeight: theme.typography.displayXlarge.fontWeight
}))

export const StyledDividerWithMargin = styled(Divider)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

export const StyledPaperTooltipWithPadding = styled(Paper)(({theme}) => ({
  elevation: 1,
  padding: theme.spacing(2)
}))

export const StyledHouseholdSubtitle = styled(Typography)(({theme, color}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: `${color} !important`
}))

// Icon styled components
export const StyledIcon = styled('div')(() => ({
  width: 15,
  height: 15,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    width: 15,
    height: 15
  }
}))

// Grid components with margins
export const StyledDiseaseGridWithMargin = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

// Stack components with margins
export const StyledOutreachStack = styled(Stack)(({theme}) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1)
}))

export const StyledOutreachDivider = styled(Divider)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

// Additional styled components for POITooltip
export const StyledPOIHeaderText = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.hpBaseDarkest
}))

export const StyledPOILabel = styled(Typography)(({theme, color}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: color || theme.palette.hpBaseDarkest
}))

export const StyledAddressLabel = styled(Typography)(({theme}) => ({
  ...theme.typography.body1,
  color: theme.palette.hpBaseDarker
}))

export const StyledAddressData = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpBaseDarkest,
  fontWeight: theme.typography.displayXlarge.fontWeight
}))

// Additional styled components for renderPersonaTooltip
export const StyledPersonaTooltipPaper = styled(Paper)(({theme}) => ({
  elevation: 1,
  padding: `${theme.spacing(0.375)} ${theme.spacing(0.625)}`,
  marginLeft: 'auto'
}))

export const StyledPersonaStackWithMargin = styled(Stack)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

// Additional styled components for renderPersonalInfo
export const StyledPersonalInfoDivider = styled(Divider)(({theme}) => ({
  marginTop: theme.spacing(1)
}))

export const StyledPersonalInfoStack = styled(Stack)(({theme}) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}))

export const StyledPersonalInfoTypography = styled(Typography)(({theme}) => ({
  ...theme.typography.body1,
  color: theme.palette.hpBaseDarker
}))

export const StyledPersonalInfoTypographyAlt = styled(Typography)(({theme}) => ({
  ...theme.typography.body2,
  color: theme.palette.hpBaseDarker
}))

export const StyledCensusTractBox = styled(Box)(({theme}) => ({
  position: 'absolute',
  top: '5%',
  right: '0.21%',
  transform: 'translate(-50%, -50%)',
  zIndex: 999
}))
